import {createGlobalStyle} from 'styled-components'
import {darkGray} from '@modifi/constants/colors'
import STYLE_CONSTANTS from './constants'

export default createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size: 16px;
    color: ${({color = darkGray}) => color};
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: ${STYLE_CONSTANTS.FONT_FAMILY};
    font-weight: ${STYLE_CONSTANTS.FONT_WEIGHT_REGULAR};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  strong {
    font-weight: ${STYLE_CONSTANTS.FONT_WEIGHT_BOLD};
  }
`
